var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayMediumCustomGlass = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.792 1.996c-.035-.121-.139-.173-.277-.173H6.15a.434.434 0 0 0-.363.173c-.086.12-.138.224-.138.363L7.6 26.153c.121 1.262 1.245 2.316 2.506 2.316h9.383c1.296 0 2.42-1.037 2.506-2.316L23.947 2.36c-.017-.139-.052-.277-.155-.363zM19.524 27.5h-9.418c-.76 0-1.434-.622-1.52-1.382h12.458c-.069.76-.777 1.382-1.52 1.382zm1.607-2.367H8.499L6.684 2.808h16.261l-1.814 22.326z",
    fill: "#1E2969"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.975 10.48a.442.442 0 0 0-.45-.086c-1.865.657-3.835.657-5.58.034a6.935 6.935 0 0 0-2.23-.345c-2.022 0-3.888.708-3.974.726-.19.086-.346.276-.311.5l.95 12.183c.035.26.225.45.484.45h9.97c.26 0 .484-.19.484-.45l.847-12.597c0-.173-.052-.328-.19-.415z",
    fill: "#1B7690"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayMediumCustomGlass);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-medium-custom-glass.8b3a777b74fceb8de510e4c6d2c5b14a.svg";